import React from "react";

interface ContentGridProps {
  title: string;
  blocks: { title: string; description: string }[];
}

const ContentGrid: React.FC<ContentGridProps> = ({ title, blocks }) => {
  return (
    <>
      <h2 className="text-3xl sm:text-4xl px-4 md:px-6 mb-8 md:mb-16 uppercase">
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
        {blocks && blocks.map(
          (
            block: { title: string; description: string },
            idx: React.Key | null | undefined
          ) => (
            <div key={idx} className="p-4 md:p-6">
              <h3 className="uppercase text-xl mb-8">{block.title}</h3>
              <div dangerouslySetInnerHTML={{__html: block.description}}/>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default ContentGrid;
